export const ADD_DEGREE = "ADD_DEGREE";
export const UPDATE_DEGREE = "UPDATE_DEGREE";
export const DELETE_DEGREE = "DELETE_DEGREE";
export const SET_DEGREE = "SET_DEGREE";